import getSelectedFilters from 'Utils/getSelectedFilters'

export const TIER_ALL = 'all'
export const TIER_ESSENTIALS = 'essentials'
export const TIER_PREMIUM = 'premium'

// Matches the backend param name so the value round-trips through ListingPage's generic
// snake_case passthrough without a dedicated mapping.
export const TIER_FILTER_KEY = 'subscription_tier_band'

const TIER_BANDS = [TIER_ESSENTIALS, TIER_PREMIUM]

// `null` means "no tier selected", which is not the same as `TIER_ALL`: picking All is what
// turns `subscribed` on for every tier, and a native radio that already renders checked does
// not fire onChange, so All must stay unchecked until the search really is an all-tier one.
export function getSelectedTier(selectedTierBand, selectedPricingFilters = []) {
  if (!selectedPricingFilters.includes('subscribed')) {
    return null
  }

  if (!selectedTierBand) {
    return TIER_ALL
  }

  return TIER_BANDS.includes(selectedTierBand) ? selectedTierBand : null
}

// Selecting a tier auto-enables the Subscription pill and drops `free`, which the backend
// treats as mutually exclusive with a subscribed search.
export function getPricingForTier(selectedPricingFilters = []) {
  const entries = selectedPricingFilters.filter((value) => value !== 'free').map((value) => [value, '1'])

  return { ...Object.fromEntries(entries), subscribed: '1' }
}

// `undefined` for All so getQueryParams drops the key and the backend falls back to the
// bands the premium gate allows.
export function buildTierFilterUpdate(tier, selectedFilters = {}) {
  const band = tier === TIER_ALL ? undefined : tier
  const pricing = getPricingForTier(getSelectedFilters(selectedFilters.pricing))

  return {
    name: TIER_FILTER_KEY,
    value: band,
    newObject: { ...selectedFilters, pricing, [TIER_FILTER_KEY]: band },
    skipGetLastSelectedFilter: true,
  }
}
